<template>
<div @click="contextmenu=false">
<v-container class="mb-5">
    <v-row justify="space-between">

      <v-col v-if="!kobetu_mode" cols="7" class="text-left d-flex align-center">
          <v-btn color="" class="mygreen white--text mr-4" to="/reserve">
            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:20px;" />
              <span>来院登録</span>
          </v-btn>
          <DialogYoyakuSearch :tantoui="dic_doctor"></DialogYoyakuSearch>
          <div style="display: inline-block; height:36px;" class="ml-4 switch_block">
              <img class="img" src="/img/switch_calender.svg" height="100%" />
              <a href="/reservelist"></a>
          </div>
      </v-col>
      <v-col v-if="kobetu_mode" cols="7" class="text-left">
              <v-btn color="" class="mr-4" @click="back_from_kobetu()">戻る</v-btn>
              <v-btn color="mygreen darken-1" class="white--text mr-2" @click="saveKobetu">保存</v-btn>
      </v-col>


      <v-col cols="5" class="text-right">
              <v-btn v-if="!kobetu_mode" color="mygreen darken-1" class="white--text mr-3" @click="kobetuMode()">個別時間設定</v-btn>
              <v-btn color="mygreen darken-1" class="white--text mr-3" @click="showDialog()">日付選択</v-btn>
              <v-btn color="mygreen darken-1" style="min-width:36px; width:36px;" class="white--text mr-3" @click="prev()"><img class="img" src="/img/icon_left.svg" style="margin-right:2px;" /></v-btn>
              <v-btn color="mygreen darken-1" class="white--text mr-3" @click="move_today()">今日</v-btn>
              <v-btn color="mygreen darken-1" style="min-width:36px; width:36px;" class="white--text" @click="next()"><img class="img" src="/img/icon_right.svg" style="margin-left: 0px;" /></v-btn>
      </v-col>
    </v-row>
</v-container>

<v-container fluid class="calendar">
    <v-row justify="space-between">
    <v-col cols="12" class="text-left">
    <schedulerlite
      ref="child"
      v-if="showChild"
      :kobetu_mode="kobetu_mode"
      :stop_saibyouga="stop_saibyouga"
      :schedule-data.sync="scData"
      :setting="setting"
      :arr_holiday="arr_holiday"
      :arr_unit="arr_unit"
      :is_contextmenu="contextmenu"
      @date-click-event="dateClickEvent"
      @click-event="clickEvent"
      @context-menu="showContextMenu"
      @add-event="addEvent"
      @move-event="moveEvent"
      @edit-event="editEvent"
      @delete-event="deleteEvent"
      @push-schedule-data-="pushScheduleData"
      @splice-schedule-data-="spliceScheduleData"
      @monshin="monshin"
      @saibyouga="saibyouga"
      @yoyaku_kakunin="yoyaku_kakunin"
      @do_stop_saibyouga="doStopSaibyouga"
      @get_yoyaku="getYoyaku"
      @close_contextmenu="closeContextMenu"
    ></schedulerlite>
    </v-col>
    </v-row>
</v-container>


      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="date_selected"
        persistent
        width="290px"
      >
        <v-date-picker
          color="green lighten-1"
          v-model="date_selected"
          scrollable
          :no-title="true"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="modal = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="clickOK()"
          >
            決定
          </v-btn>
        </v-date-picker>
      </v-dialog>

            <div :style="menu_position" v-show="contextmenu">
            <ul class="el_contextMenu__colorful text-left">
                <li @click="clickContextMenu(1)" style="background:#F0F0F0"><a href="#">受付</a></li>
                <li @click="clickContextMenu(2)" style="background:#F0F0F0"><a href="#">診察</a></li>
                <li @click="clickContextMenu(3)" style="background:#F0F0F0"><a href="#">会計済</a></li>
                <li @click="clickContextMenu(4)" style="background:#F0F0F0"><a href="#">キャンセル</a></li>
            </ul>
            </div>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import schedulerlite from "@/components/SchedulerLite.vue";
import axios from 'axios';
import {mapGetters} from 'vuex'
import DialogYoyakuSearch from '@/components/DialogYoyakuSearch.vue';
/* eslint-disable */

const sampleData = [
  {
    title: "1",
    schedule: []
  },
  {
    title: "2",
    schedule: [
      {
        text: "Mr.C reserved",
        start: "2020/04/20 12:00",
        end: "2020/04/20 17:00",
        data: {
          something: "something"
        }
      }
    ]
  },
  {
    title: "3",
    schedule: []
  },
  {
    title: "4",
    schedule: []
  },
  {
    title: "5",
    schedule: []
  },
  {
    title: "A",
    schedule: []
  },
  {
    title: "B",
    schedule: []
  },
];


const weekdayText = ["日", "月", "火", "水", "木", "金", "土"];

let today = dateFormatter(new Date(), false);
console.log('today', today);

let settings = {
  startDate: today,
  endDate: today,
  weekdayText: weekdayText,
  unit: 15, // Minutes
  borderW: 1,    //
  dateDivH: 35,  //  1マス分の高さ
  timeDivH: 25,  //
  unitDivW: 160,  // 1マス分の幅 146
  titleDivW: 20, // Percent
  rowH: 2135      // .timelineの高さ
};



/* eslint-disable */
    /**
     * Custom date formatter
     *
     * @param Obejct  dateObj     DateObejct
     * @param Boolean withWeekDay If u need weekday, set True
     *
     * @returns String
     */
    function dateFormatter(dateObj, withWeekDay) {
      let year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let date = dateObj.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      if (withWeekDay) {
        let day = dateObj.getDay();
        let dayText = settings.weekdayText[day];
        return year + "/" + month + "/" + date + "(" + dayText + ")";
      }
      return year + "/" + month + "/" + date;
    }

    /**
     * Custom datetime formatter
     *
     * @param Obejct  dateObj     DateObejct
     *
     * @returns String
     */
    function datetimeFormatter(dateObj) {
      let year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let date = dateObj.getDate();
      let hours = dateObj.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      let minutes = dateObj.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return year + "/" + month + "/" + date + " " + hours + ":" + minutes;
    }
/* eslint-disable */


export default {
  name: "App",
  components: {
    schedulerlite: schedulerlite,
    DialogYoyakuSearch
  },

  data: function() { // datas
    return {

      scData: sampleData,  // カレンダーのデータ
      mydate: '',   // scDataのリクエスト日付

      stop_saibyouga: false,
      kobetu_mode: false,
      dic_doctor: [{'id': 1, 'doctor':'医師一太'}],

      arr_unit:[],
      arr_holiday:
        {
            0:[53,54],
            1:[53,54],
            2:[53,54],
            3:[53,54],
            4:[53,54],
            5:[53,54],
            6:[53,54],
        },
      contextmenu: false,   // コンテキストメニュー表示フラグ
      rowIndex: 0,
      reserve_id: 0,
      menu_position: {
          position: 'absolute',
          left: 0,
          top: 0
      },

      today: today,
      showChild: true,  // 子コンポーネント再描画用フラグ
      setting: settings,



      // 日付選択
      date_selected: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      modal: false


    };  // datas
  },

  created() {  // 親
        console.log('%c created: ReserveCalendar.vue', mycolor.created)

        this.get_tantoui();


        // 予約一覧を取得
        let date = this.$route.params.date ? this.$route.params.date : this.today.replace(/\//mg, '');
        let date_text = date.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3');
        this.setting.startDate = date_text;
        this.setting.endDate = date_text;
        this.mydate = date;
        console.log('%c mydate:', mycolor.strong, this.mydate);
        console.log('date_text: ', date_text);

        this.getArrHoliday(date);
        this.getUnit();

        axios.get('/reserve_calendar/' + date )
          .then((res) => {
              console.log('------------------------------');
              console.group();
              console.log('%c %s', mycolor.api, '/reserve_calendar/'+date);
              console.log('予約一覧を取得');
              console.log(res.data);
              console.groupEnd();


              this.scData = res.data;

              // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
              this.showChild = false;
              this.$nextTick( () => (this.showChild = true) );

          })
          .catch( e => {
              console.error(e);
          });

  },
    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

  methods: {
        closeContextMenu(){
            console.log('%c %s', mycolor.strong, 'closeContextMenu()');
            this.contextmenu = false;
        },
        getYoyaku(){
            console.log('%c %s', mycolor.api, 'ReserveCalendar: getYoyaku()');

            axios.get('/reserve_calendar/' + this.mydate )
              .then((res) => {
                  console.log('------------------------------');
                  console.group();
                  console.log('%c %s', mycolor.api, '/reserve_calendar/'+this.mydate);
                  console.log('getYoyaku()');
                  console.log('予約一覧を取得');
                  console.log(res.data);
                  console.groupEnd();

                  this.scData = res.data;

                  // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
                  this.showChild = false;
                  this.$nextTick( () => (this.showChild = true) );


              })
              .catch( e => {
                  console.error(e);
              });

        },  // getYoyaku()


        get_tantoui(){
            // 担当医の辞書を取得
            axios.get('/get_doctors')
            .then((res) => {
                console.group();
                console.log('%c /get_doctors', mycolor.api);
                console.log('担当医のリスト取得');
                console.log('res: ', res.data);
                console.groupEnd();
                this.dic_doctor = res.data;
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error);
            });
        },

        yoyaku_search(){
            console.log('yoyaku_search()');
        },

        // グレーアウトするkeyIndex(masuno)を返す
        getArrHoliday(_date){
            console.log('getArrHoliday()');
            console.log('_date', _date);

            let api = '/get_arr_holiday/'+_date;
            axios.get(api)
              .then((res) => {
                console.log('------------------------------');
                console.log(`%c${api}`, mycolor.orange);
                console.log('get_arr_holiday 完了');
                console.log(res.data);
                this.arr_holiday = res.data;

              })
              .catch( (e) => {
                // eslint-disable-next-line
                console.error(e);
              });
        },

        // untouchableにするunit番号の配列を返す
        getUnit(){

            axios.get('/get_untouchable')
              .then((res) => {
                console.log('------------------------------');
                console.log('/get_untouchable', mycolor.orange);
                console.log(res.data);
                this.arr_unit = res.data;

              })
              .catch( (e) => {
                // eslint-disable-next-line
                console.error(e);
              });
        },

    // 再描画
    saibyouga(data){
          console.log('再描画');
          console.log(data);
          console.log(this.scData);

        this.stop_saibyouga = false;
        if(data==='from_monshin'){
            return false;
        }


        let target_no = 0;
        let len_scData = this.scData[data.rowIndex]['schedule'].length;
        for(let i=0; i<len_scData; i++){
            console.log(this.scData[data.rowIndex]['schedule'][i]['id']);
            if( this.scData[data.rowIndex]['schedule'][i]['id']===this.reserve_id  ){
                target_no = i;
                continue;
            }
        }



        let syochi_text = [];
        for (const [key, value] of Object.entries(data)) {
            if(['p_syochi', 'c_syochi', 'hotei', 'basshi', 'yobou'].includes(key) && value.length>0){
                syochi_text.push(value);
                console.log(`${key}: ${value}`);
            }
        }

          this.scData[data.rowIndex]['schedule'][target_no]['syochi_text'] = syochi_text.join();
          console.log('syochi_text', syochi_text);
          console.log(this.scData[data.rowIndex]['schedule'][target_no]['syochi_text'] );


          // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
          this.showChild = false;
          this.$nextTick( () => (this.showChild = true) );
          console.log('再描画完了');

    },  // saibyouga()

    yoyaku_kakunin(data){
        console.log('yoyaku_kakunin()', data);

        let api = '/pre_sendmail';
        axios.post(api, data)
          .then((res) => {
            console.log('------------------------------');
            console.log(`%c${api}`, mycolor.orange);
            console.log('ステータス更新完了');
            console.log(res.data);

            // todo: リロードなしに反映したい.
            location.href=this.$route.fullPath;
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });

    },


    doStopSaibyouga(){
        console.log('doStopSaibyouga()');
        this.stop_saibyouga = true;
    },



    monshin(){
      console.log("------");
      console.log("monshin:");

    },
    clickEvent(startDate, endDate, text, reserve_id) {
      console.log("------");
      console.log("ClickEvent:");
      console.log("StartDate:" + startDate);
      console.log("EndDate:" + endDate);
      console.log("ContentText:" + text);
      console.log('reserve_id', reserve_id);
      const path = '/reserve/'+reserve_id;
      this.$router.push(path).catch(()=>{});
    },
    showContextMenu(reserve_id, index, e) {
      console.log("------");
      console.log("contextMenu:");
      console.log("reserve_id", reserve_id);
      console.log("index", index);
      console.log(e);
      console.log(e.pageY);
      console.log(e.pageX);
      this.contextmenu = true;
      this.menu_position = {
        position: 'absolute',
        top: `${e.pageY-30}px`,
        left: `${e.pageX-60}px`
      };
      this.rowIndex = index;
      this.reserve_id = reserve_id;

    },
    clickContextMenu(no){
        console.log('clickContextMenu()');
        console.log('no', no);
        let target_no = 0;
        let len_scData = this.scData[this.rowIndex]['schedule'].length;
        for(let i=0; i<len_scData; i++){
            console.log(this.scData[this.rowIndex]['schedule'][i]['id']);
            if( this.scData[this.rowIndex]['schedule'][i]['id']===this.reserve_id  ){
                target_no = i;
                continue;
            }
        }
        this.scData[this.rowIndex]['schedule'][target_no]['back_color'] = this.$colors[no];
        this.showChild = false;
        this.$nextTick( () => (this.showChild = true) );

        let new_status = ['予約', '受付', '診察', '会計済', 'キャンセル', '経過'][no];
        let api = ''
        let send_mail = 1;

        if( new_status==='キャンセル' ){
            let ret = window.confirm('患者にキャンセルメールを送りますか？')
            send_mail = ret ? true : false;

            axios.get('/reserve_cancel/'+this.reserve_id+'?is_sendmail='+send_mail)
              .then((res) => {
                  console.log('------------------------------');
                  console.group();
                  console.log('%c %s', mycolor.api, '/reserve_cancel/'+this.reserve_id+'?is_sendmail='+send_mail);
                  console.log('キャンセル完了');
                  console.log(res.data);
                  console.groupEnd();

                  this.getYoyaku(); // scData再取得

                  // todo: リロードなしに反映したい.
                  //location.href=this.$route.fullPath;
              })
              .catch( e => {
                  // eslint-disable-next-line
                  console.error(e);
              });


        }else{
            // キャンセル以外
            // QRコードでは、'bangou' と 'new_status'が入ってくる.
            axios.post('/reserve_update', {
                  'reserve_id': this.reserve_id,
                  'new_status': new_status
              })
              .then((res) => {
                  console.log('------------------------------');
                  console.group();
                  console.log('%c %s', mycolor.api, '/reserve_update');
                  console.log(`%c${api}`, mycolor.orange);
                  console.log('ステータス更新完了: '+new_status);
                  console.log(res.data);
                  console.groupEnd();

                  this.getYoyaku(); // scData再取得

              })
              .catch( e => {
                  // eslint-disable-next-line
                  console.error(e);
              });
        }


    },
        kobetuMode(){
            console.log('kobetuMode()');
            this.kobetu_mode = true;

        },
        back_from_kobetu(){
            console.log('back_from_kobetu()');
            this.kobetu_mode = false;


            // 子コンポーネント再描画 (v-ifの値が変わると再描画が起こることを利用)
            this.showChild = false;
            this.$nextTick( () => (this.showChild = true) );
            console.log('再描画完了');
        },
        saveKobetu(){
            this.kobetu_mode = true;
            // todo: api呼び出し.
            let eles = document.querySelectorAll("[data-masu]");
            let arr_masu = {0:[], 1:[], 2:[], 3:[], 4:[]};
            eles.forEach(el=>{
                let unitno = el.getAttribute('data-masu').split(':')[0]*1;
                let masuno = el.getAttribute('data-masu').split(':')[1]*1;
                if(masuno<=36 || unitno>=5){
                    return;
                }

                if(el.classList.contains('gray')){
                    arr_masu[unitno].push(masuno*1)
                }
//                console.log(el);
            });


          let api = '/save_kobetu'
          axios.post(api, {date: this.setting.startDate , arr_masu: arr_masu})
          .then((res) => {
            console.log('------------------------------');
            console.log(`%c${api}`, mycolor.orange);
            this.kobetu_mode = false;
            location.reload();
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });


            console.log('saveKobetu()');
            console.log(arr_masu);
        },
        showDialog(){
            this.modal = true;
            console.log('showDialog()');
        },
        prev(){
            console.log('prev()');
            console.log(this.setting.startDate);
            let yesterday = new Date( this.setting.startDate );
            yesterday.setDate(yesterday.getDate()-1);
            yesterday = dateFormatter(yesterday, false).replace(/\//mg, '');
            console.log('yesterday', yesterday);
            location.href = '/reservecalendar/'+yesterday;
        },
        next(){
            console.log('next()');
            console.log(this.setting.startDate);
            let tomorrow = new Date( this.setting.startDate );
            tomorrow.setDate(tomorrow.getDate()+1);
            tomorrow = dateFormatter(tomorrow, false).replace(/\//mg, '');
            console.log('tomorrow', tomorrow);
            location.href = '/reservecalendar/'+tomorrow;
        },
        move_today(){
            console.log('move_today()');
            console.log(this.setting.startDate);
            location.href = '/reservecalendar/';
        },
        clickOK(){
            console.log('clickOK()');
            console.log(this.date_selected);
            this.$refs.dialog.save(this.date_selected);

            //todo: 本当は $router.push() のほうが良いか?
            location.href = '/reservecalendar/'+this.date_selected.replace(/-/mg, '');

        },


    pushScheduleData(rowIndex, data){
          console.log("------");
          console.log('pushScheduleData()');

      this.scheduleData[rowIndex].schedule.push(data);
    },


    spliceScheduleData(rowIndex, keyNo){
          console.log("------");
          console.log('spliceScheduleData()');

          this.scheduleData[rowIndex].schedule.splice(keyNo, 1);
    },


    dateClickEvent(date) {
      console.log("------");
      console.log("DateClickEvent:");
      console.log("Date:" + date);
    },
    addEvent(rowIndex, startDate, endDate) {
      console.log("------");
      console.log("addEvent():");
      console.log("RowIndex:" + rowIndex);
      console.log("StartDate:" + startDate);
      console.log("EndDate:" + endDate);
    },
    moveEvent(status, newStartDate, newEndDate) {
      // イベントの移動が成功したかをconsole表示させるだけ.
      console.log("------");
      console.log("親: MoveEvent:");
      if (status == 1) {
        console.log("NewStartDate:" + newStartDate);
        console.log("NewEndDate:" + newEndDate);
      } else if (status == 2) {
        console.log("Has other event, can't move.");
      } else {
        console.log("Not businessDay, can't move.");
      }
    },
    editEvent(newStartDate, newEndDate) {
      console.log("------");
      console.log("EditEvent:");
      console.log("NewStartDate:" + newStartDate);
      console.log("NewEndDate:" + newEndDate);
    },
    deleteEvent(row, index) {
      console.log("------");
      console.log("DeleteEvent:");
      console.log("Row:" + row);
      console.log("Index:" + index);
    },
    addNewRow() {
      // UNITを追加
      let newTitle = "Room" + (this.scData.length + 1);
      this.scData.push({
        title: newTitle,
        schedule: []
      });
    }
  }
};

</script>

<style scoped>
.sample {
  width: 10px;
  height: 10px;
  margin: 5px;
  border: 1px solid black;
}

.cant-res {
  background-color: #999 !important;
}

.reserved {
  background-color: #ec920a !important;
}
.calendar{
    min-height: 1750px;
    overflow: hidden;
}
.calendar .container{
}


.el_contextMenu__colorful{
  box-sizing: border-box;
  position: absolute;
  z-index: 999999999;
  padding: 0;
  width: 200px;
}
.el_contextMenu__colorful li {
    box-sizing: border-box;
    list-style: none;
    transition: box-shadow 0.1s;
}
.el_contextMenu__colorful li:hover {
  box-sizing: border-box;
  box-shadow: 0 0 4px #000;
  border-bottom: solid 2px #b3b3b3;
}
.el_contextMenu__colorful li > a {
  padding: 0.5em 1em;
  padding-right:3em;
  color: #3f3f3f;
  text-decoration: none;
  display: block;
  height: 100%;
}

.switch_block{
    display: inline-block;
    position: relative;
}
.switch_block a{
    cursor: pointer;
    position: absolute;
    top:0;
    left:50%;
/*    background: blue; */
    width: 50%;
    height: 100%;
}
</style>
